<script>
  import { SortableList } from "@jhubbardsf/svelte-sortablejs";
  import {
    sortablePreventUnmovableItemsFromMoving,
    sortableForceFallbackForFirefox,
  } from "./genericHandlers";
  import { CardKinds } from "./SoundCard";
  import Card from "./SoundCard.svelte";
  import LaneFillerMessage from "./LaneFillerMessage.svelte";
  import { GuidedSceneSettingIds } from "./GuidedSceneSettings";

  const CROSSFADE_DURATION_MILLIS = 5000;
  const STOP_FADEOUT_DURATION_MILLIS = 1000;

  export let scene;
  export let handleAdd;
  export let handleRemove;
  export let handleUpdate;
  export let handleStart;
  export let handleEnd;
  export let handleChoose;
  export let handleNameChange;
  export let handlePlaySettingsChange;
  export let soundsAreCloseable = true;

  let cards = [];

  function findNextSound(startIdx) {
    let i = startIdx + 1;
    while (i < cards.length && !cards[i]) {
      i++;
    }
    return i;
  }
  function handleSoundEnded(idx) {
    if (!scene.settings.getValue(GuidedSceneSettingIds.IsMusicAPlaylist)) {
      return;
    }
    if (scene.settings.getValue(GuidedSceneSettingIds.MusicCrossfadeEnabled)) {
      return; // We've already started playing the next sound
    }
    const nextIdx = findNextSound(idx);
    if (nextIdx >= cards.length) {
      return; // We have reached the end of the playlist
    }
    cards[nextIdx].play();
  }

  let fadingOutSoundIdx = -1;
  function handleSoundAboutToEnd(idx) {
    if (!scene.settings.getValue(GuidedSceneSettingIds.IsMusicAPlaylist)) {
      return;
    }
    if (!scene.settings.getValue(GuidedSceneSettingIds.MusicCrossfadeEnabled)) {
      return;
    }
    if (fadingOutSoundIdx == idx) {
      return;
    }
    const nextIdx = findNextSound(idx);
    if (nextIdx >= cards.length) {
      return; // We have reached the end of the playlist
    }
    fadingOutSoundIdx = idx;
    cards[idx].fadeout(CROSSFADE_DURATION_MILLIS);
    cards[nextIdx].fadein(CROSSFADE_DURATION_MILLIS);
  }

  function handlePlayClicked(idx) {
    if (scene.settings.getValue(GuidedSceneSettingIds.IsMusicAPlaylist)) {
      stopAllExcept(idx);
    }
  }

  export function stopCardAtIdx(idx) {
    cards[idx].stop();
  }

  export function stopAllExcept(idx) {
    if (idx === undefined) {
      idx = -1;
    }
    for (let i = 0; i < cards.length; i++) {
      if (i !== idx && cards[i]) {
        if (
          scene.settings.getValue(GuidedSceneSettingIds.MusicCrossfadeEnabled)
        ) {
          cards[i].fadeout(STOP_FADEOUT_DURATION_MILLIS);
        } else {
          cards[i].stop();
        }
      }
    }
  }

  export function startPlaying() {
    if (
      !scene.settings.getValue(
        GuidedSceneSettingIds.StartMusicWhenStartingScene,
      )
    ) {
      return;
    }
    stopAllExcept(0);
    if (cards[0]) {
      cards[0].play();
    }
  }
</script>

<div class="guided-scene-music-header">
  <strong class="light">Music:</strong>
</div>
<SortableList
  class="soundboard-lane-container"
  swapThreshold={0.75}
  animation={250}
  easing="ease-in-out"
  onAdd={(evt) => handleAdd(evt, CardKinds.Music)}
  onRemove={(evt) => handleRemove(evt, CardKinds.Music)}
  onUpdate={(evt) => handleUpdate(evt, CardKinds.Music)}
  onStart={(evt) => handleStart(evt, CardKinds.Music)}
  onEnd={(evt) => handleEnd(evt, CardKinds.Music)}
  onChoose={(evt) => handleChoose(evt, CardKinds.Music)}
  onMove={sortablePreventUnmovableItemsFromMoving}
  forceFallback={sortableForceFallbackForFirefox()}
  handle=".soundcard-header"
  filter=".unsortable"
  group={{ name: "sounds-on-lanes" }}
  ghostClass="sound-ghost"
>
  {#if scene.music.cards.length !== 0}
    {#each scene.music.cards as card, cardIdx (card.id)}
      <Card
        {card}
        sceneId={scene.id}
        onPlaybackEnd={() => handleSoundEnded(cardIdx)}
        onPlayClicked={() => handlePlayClicked(cardIdx)}
        onSoundAboutToEnd={() => handleSoundAboutToEnd(cardIdx)}
        playSettingsChangedCallback={handlePlaySettingsChange}
        nameChangeCallback={handleNameChange}
        crossfadeDurationMillis={CROSSFADE_DURATION_MILLIS}
        closeable={soundsAreCloseable}
        sceneVolume={scene.globalVolume}
        bind:this={cards[cardIdx]}
      />
    {/each}
  {:else}
    <LaneFillerMessage
      msg={"Search the library for some music that has the mood you want to evoke. 2 or 3 tracks are enough."}
    />
  {/if}
</SortableList>
